import { IVersion } from "@logex/framework/lg-application";

export interface Version extends IVersion {
    buildNumber: number;
}
